import React, { useState } from "react";
import { Button, Paper, Typography, Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { useForm } from "react-hook-form";

const useStyles = makeStyles()(() => ({
  formContainer: {
    maxWidth: "600px",
    margin: "auto",
    padding: "20px",
    marginTop: "40px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  inputField: {
    marginBottom: "16px",
  },
  // buttonGroup: {
  //   display: "flex",
  //   justifyContent: "space-between",
  //   marginTop: "20px",
  // },
  errorText: {
    color: "red",
    fontSize: "0.9rem",
    marginTop: "1px",
    marginBottom: "10px",
  },
}));

const CreateUser = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  // Handle form submission
  const onSubmit = async (data) => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    try {
      setLoader(true);

      // Retrieve the token from localStorage
      const token = localStorage.getItem("userToken");

      // Set up the headers with the token
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.post(`${API_BASE_URL}/user/create-user`, data, { headers });

      if (response?.data?.status === "SUCCESS") {
        Swal.fire({
          title: "User Created",
          text: "The user has been successfully created.",
          icon: "success",
          confirmButtonText: "Okay",
        });
        navigate("/user-list"); // Redirect to the user list page
      } else {
        Swal.fire({
          title: "Creation Failed",
          text: response?.data?.message || "Failed to create the user. Please try again.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while creating the user. Please try again later.",
        icon: "error",
        confirmButtonText: "Close",
      });
      console.error("Error during user creation:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Paper className={classes.formContainer}>
      <Typography variant="h5" gutterBottom>
        Create New User
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <label>Name</label>
            <input
              type="text"
              {...register("name", {
                required: "Name is required",
                minLength: { value: 3, message: "Name must be at least 3 characters long" },
              })}
              className="form-control"
            />
            {errors?.name && <p className={classes.errorText}>{errors?.name?.message}</p>}
          </Grid>

          <Grid item xs={12}>
            <label>Email</label>
            <input
              type="email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Enter a valid email address",
                },
              })}
              className="form-control"
            />
            {errors?.email && <p className={classes.errorText}>{errors?.email?.message}</p>}
          </Grid>

          <Grid item xs={12}>
            <label>Mobile</label>
            <input
              type="text"
              {...register("mobile", {
                required: "Mobile number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Mobile number must be 10 digits",
                },
              })}
              className="form-control"
            />
            {errors?.mobile && <p className={classes.errorText}>{errors?.mobile?.message}</p>}
          </Grid>

          <Grid item xs={12}>
            <label>Date of Birth</label>
            <input
              type="date"
              {...register("dob", { required: "Date of Birth is required" })}
              className="form-control"
            />
            {errors?.dob && <p className={classes.errorText}>{errors?.dob?.message}</p>}
          </Grid>

          <Grid item xs={12}>
            <label>Password</label>
            <input
              type="password"
              {...register("password", {
                required: "Password is required",
                minLength: { value: 8, message: "Password must be at least 8 characters" },
                maxLength: { value: 15, message: "Password cannot exceed 15 characters" },
              })}
              className="form-control"
            />
            {errors?.password && <p className={classes.errorText}>{errors?.password?.message}</p>}
          </Grid>
        </Grid>
        <div className="buttonGroup_add">
          <Button
            variant="outlined"
            onClick={() => navigate("/user-list")}
            disabled={loader}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loader}
          >
            {loader ? "Creating..." : "Create User"}
          </Button>
        </div>
      </form>
    </Paper>
  );
};

export default CreateUser;
